import { ReportAPI } from 'api'
import { reject } from 'lodash/fp'
import { isUuidString, omitUuid } from '../../utils'
import { ReportFormValues } from './components/ReportForm'

/**
 *
 * @param values formik values of ReportForm
 * @param reportLines reportLines from API
 * @returns
 */
export function normalizeFormToApi(values: ReportFormValues) {
  return {
    report: {
      channel: values.channel,
      reportLinesAttributes: [
        {
          fieldName: 'jenis_pengaduan',
          fieldType: 'text',
          // this will add id and other fields
          ...values.reportType,
        },
        {
          fieldName: 'apa_yang_terjadi',
          fieldType: 'text',
          ...values.whatHappened,
        },
        {
          fieldName: 'siapa_saja_yang_terlibat',
          fieldType: 'array',
          ...values.involvedParties,
          valueName: values.involvedParties.valueName.map(omitUuid),
        },
        {
          fieldName: 'kapan_terjadinya',
          fieldType: 'array',
          ...values.timeOfEvents,
          valueName: values.timeOfEvents.valueName.map(omitUuid),
        },
        {
          fieldName: 'dokumen_pendukung',
          fieldType: 'attachments',
          valueName: '',
          ...values.attachments,
          attachmentIds: values.attachments.attachments.map((at) => at.id),
          deleteAttachmentByIds: reject(isUuidString)(
            values.deleteAttachmentByIds
          ),
        },
      ],
    },
  }
}

/**
 *
 * @param report Report object from API response
 * @returns values for ReportForm
 */
export function normalizeApiToForm(report: ReportAPI.Data): ReportFormValues {
  const values: any = {
    channel: report.channel,
    finalNotes: report.finalNotes,
  }

  report.reportLines?.forEach((reportLine) => {
    switch (reportLine.fieldName) {
      case 'jenis_pengaduan':
        values.reportType = { ...reportLine }
        break
      case 'apa_yang_terjadi':
        values.whatHappened = { ...reportLine }
        break
      case 'siapa_saja_yang_terlibat':
        values.involvedParties = { ...reportLine }
        break
      case 'kapan_terjadinya':
        values.timeOfEvents = { ...reportLine }
        break
      case 'dokumen_pendukung':
        values.attachments = { ...reportLine }
        break
      default:
        break
    }
  })

  return values
}
